customElements.get("video-player") || customElements.define("video-player", class extends HTMLElement {
  video=this.querySelector("video");
  primaryPlayButton=this.querySelector("[data-play]");
  customControls=this.querySelector("div[data-controls]");
  runningButton=this.customControls?.querySelector("[data-toggle-running]") || null;
  volumeButton=this.customControls?.querySelector("[data-toggle-volume]") || null;
  hideOnPlay=this.querySelectorAll("[data-hide]");
  observer;
  constructor() {
    super(), this.updateControlState = this.updateControlState.bind(this);
  }
  play() {
    this.video.readyState && (this.stopAll(), this.video.play(), this.hideOnPlay.forEach(t => t.style.display = "none"), 
    this.customControls.classList.remove("hidden"));
  }
  stop() {
    this.video.readyState && this.video.pause();
  }
  stopAll() {
    document.querySelectorAll("video").forEach(t => t.readyState && t.pause());
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(t => {
      t.forEach(t => {
        t.isIntersecting || this.video.paused ? this.video.hasAttribute("autoplay") && t.isIntersecting && this.play() : this.stop();
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: .1
    }), this.observer.observe(this.video);
  }
  updateControlState(t, e) {
    const s = t?.querySelectorAll("span");
    s.length && (e ? (s[0].classList.remove("hidden"), s[1].classList.add("hidden")) : (s[0].classList.add("hidden"), 
    s[1].classList.remove("hidden")));
  }
  disconnectedCallback() {
    this.observer && this.observer.disconnect();
  }
  connectedCallback() {
    if (!this.video) return !1;
    const t = this.video.hasAttribute("autoplay");
    this.updateControlState(this.runningButton, !t), this.updateControlState(this.volumeButton, !this.video.muted), 
    this.primaryPlayButton?.addEventListener("click", t => {
      t.preventDefault(), t.stopPropagation(), this.play();
    }), this.video.addEventListener("click", t => this.video.paused ? this.play() : this.stop()), 
    this.video.addEventListener("pause", () => {
      this.updateControlState(this.runningButton, !0);
    }), this.video.addEventListener("play", () => {
      this.updateControlState(this.runningButton, !1);
    }), this.video.addEventListener("volumechange", () => {
      this.updateControlState(this.volumeButton, !this.video.muted);
    }), this.runningButton?.addEventListener("click", t => {
      t.preventDefault(), t.stopPropagation(), this.video.paused ? this.play() : this.stop();
    }), this.volumeButton?.addEventListener("click", t => {
      t.preventDefault(), t.stopPropagation(), this.video.muted = !this.video.muted;
    }), this.setupIntersectionObserver();
  }
});